import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactJWPlayer from 'react-jw-player';
import { JW_PLAYER_TYPE_FILE, VIDEO_WRAPPER_CLASS_NAME } from '../../../../constants';
import JWPlayerController from './JWPlayerController';
import { VideoContext } from '../../VideoContext';
const JWPlayerProvider = ({
  url,
  name,
  autoplay,
  controls,
  type,
  urlScript,
  muted,
  imageData,
  loop: repeat
}) => {
  const {
    emitEvent
  } = useContext(VideoContext);
  const PlayerController = useRef(new JWPlayerController({
    emitEvent
  }));
  const handleOnReady = () => {
    const jwPlayer = window.jwplayer(name);
    if (jwPlayer) {
      PlayerController.current.setPlayer(jwPlayer);
    }
  };
  const getJWPlayerProps = () => {
    const {
      events
    } = PlayerController.current;
    const props = {
      customProps: {
        repeat,
        controls,
        events
      },
      playerScript: urlScript,
      isAutoPlay: autoplay,
      isMuted: muted,
      playerId: name,
      onReady: handleOnReady,
      className: VIDEO_WRAPPER_CLASS_NAME
    };
    if (type === JW_PLAYER_TYPE_FILE) {
      const {
        url: imageURL = ''
      } = imageData;
      return _objectSpread(_objectSpread({}, props), {}, {
        image: imageURL,
        file: url
      });
    }
    return _objectSpread(_objectSpread({}, props), {}, {
      playlist: url
    });
  };
  return /*#__PURE__*/React.createElement(ReactJWPlayer, getJWPlayerProps());
};
JWPlayerProvider.propTypes = {
  url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  urlScript: PropTypes.string.isRequired,
  imageId: PropTypes.string,
  autoplay: PropTypes.bool,
  loop: PropTypes.bool,
  controls: PropTypes.bool,
  muted: PropTypes.bool,
  type: PropTypes.string,
  imageData: PropTypes.object
};
JWPlayerProvider.defaultProps = {
  autoplay: false,
  loop: false,
  controls: true,
  muted: false,
  type: 'playlist',
  imageId: null,
  imageData: {}
};
export default JWPlayerProvider;
//# sourceMappingURL=JWPlayerProvider.js.map